import { useEffect } from 'react';
import { ControlPosition, StyleChangedEvent, control } from 'azure-maps-control';
import { Box } from '@mui/material';

import {
  FullScreenContainer,
  HandleScrollWheelLayer,
  ZoomControlsContainer,
  useAzureMap
} from '@chr/online-shared-ui-maps';

import { useTrackingMap } from './TrackingMapProvider';
import { MapTypes } from './MapThemeProvider';


export function MapControls() {
  const { isMapReady, map } = useAzureMap();
  const { isFullScreen, setIsFullScreen, setMapType } = useTrackingMap();

  useEffect(() => {
    if (map && isMapReady) {
      map.controls.add(new control.StyleControl({ mapStyles: ['road', 'grayscale_dark', 'satellite'] }), { position: ControlPosition.BottomLeft });
      map.events.add('stylechanged', (e: StyleChangedEvent) => setMapType(e.style as MapTypes));
    }
  }, [isMapReady, map]);

  return (
    <>
      <ZoomControlsContainer
        sx={{
          position: 'absolute',
          right: '30px',
          bottom: '120px'
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          top: '30px',
          right: '30px'
        }}
      >
        <FullScreenContainer isFullscreen={isFullScreen} onFullScreenToggle={setIsFullScreen} />
      </Box>
      <HandleScrollWheelLayer />
    </>
  );
}
